<template>
	<div class="page-register">
		<div class="register-wrap">
			
			<div class="page-title">{{ $t('register.title') }}</div>
			
			<div class="form-wrap">
				<div class="form-item">
					<div class="form-floating">
						<input class="form-control" type="text" id="nameFloat" :placeholder="$t('nameSurname')" v-model="registerForm.name">
						<label for="nameFloat">{{ $t('nameSurname') }}</label>
					</div>
					<div v-if="v$.registerForm.name.$error && v$.registerForm.name.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
				</div>
				
				<div class="form-item">
					<div class="form-floating">
						<input class="form-control" type="email" id="emailFloat" :placeholder="$t('email')" v-model="registerForm.email">
						<label for="emailFloat">{{ $t('email') }}</label>
					</div>
					<div v-if="v$.registerForm.email.$error && v$.registerForm.email.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
					<div v-if="v$.registerForm.email.$error && v$.registerForm.email.email.$invalid" class="invalid-feedback">
						{{ $t('validation.email') }}
					</div>
				</div>
				
				<div class="form-item">
					<div class="form-floating">
						<input class="form-control" type="text" id="personalNumberFloat" :placeholder="$t('personalNumber')" v-model="registerForm.personalNumber">
						<label for="personalNumberFloat">{{ $t('personalNumber') }}</label>
					</div>
					<div v-if="v$.registerForm.personalNumber.$error && v$.registerForm.personalNumber.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
				</div>
				
				<div class="form-item">
					<div class="form-floating">
						<DivisionSelect id="divisionFloat" v-model="registerForm.division" />
						<label for="divisionFloat">{{ $t('register.division') }}</label>
					</div>
					<div v-if="v$.registerForm.division.$error && v$.registerForm.division.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
				</div>
				
				<div class="form-item">
					<div class="form-floating">
						<TeamSelect id="teamFloat" v-model="registerForm.team" :division="registerForm.division" />
						<label for="teamFloat">{{ $t('register.team') }}</label>
					</div>
					<div v-if="v$.registerForm.team.$error && v$.registerForm.team.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
				</div>
				
				<div class="form-item">
					<div class="form-floating">
						<input class="form-control" type="password" id="passwordFloat" :placeholder="$t('password')" v-model="registerForm.password">
						<label for="passwordFloat">{{ $t('password') }}</label>
					</div>
					<div v-if="v$.registerForm.password.$error && v$.registerForm.password.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
					<div v-if="v$.registerForm.password.$error && v$.registerForm.password.minLength.$invalid" class="invalid-feedback">
						{{ $t('validation.min', [v$.registerForm.password.minLength.$params.min]) }}
					</div>
				</div>
				<div class="form-item">
					<div class="form-floating">
						<input class="form-control" type="password" id="passwordConfirmFloat" :placeholder="$t('passwordConfirm')" v-model="registerForm.passwordConfirm">
						<label for="passwordConfirmFloat">{{ $t('passwordConfirm') }}</label>
					</div>
					<div v-if="v$.registerForm.passwordConfirm.$error && v$.registerForm.passwordConfirm.required.$invalid" class="invalid-feedback">
						{{ $t('validation.required') }}
					</div>
					<div v-if="v$.registerForm.passwordConfirm.$error && v$.registerForm.passwordConfirm.minLength.$invalid" class="invalid-feedback">
						{{ $t('validation.min', [v$.registerForm.passwordConfirm.minLength.$params.min]) }}
					</div>
					<div v-if="v$.registerForm.passwordConfirm.$error && !v$.registerForm.passwordConfirm.required.$invalid && !v$.registerForm.passwordConfirm.minLength.$invalid && v$.registerForm.passwordConfirm.sameAsPassword.$invalid" class="invalid-feedback">
						{{ $t('validation.passwordConfirm') }}
					</div>
				</div>
				
			</div>
			
			<div v-if="loading" class="loading spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
			
			<button :disabled="loading" type="submit" class="btn btn-primary-gradient btn-submit" @click="submitRegister">{{ $t('submitRegister') }}</button>
			
<!--			<div v-if="registerSuccess" class="valid-feedback submit-feedback">{{ $t('register.success') }}</div>-->
			<div v-if="registerError" class="invalid-feedback submit-feedback">{{ $t('validation.serverError') }}</div>
			
			<div class="modal fade" id="registerSuccessModal" tabindex="-1" aria-labelledby="registerSuccessModalLabel" aria-hidden="true">
				<div class="modal-dialog">
					<div class="modal-content">
						<div class="modal-header">
							<div class="modal-title fs-5" id="registerSuccessModalLabel">{{ $t('register.successTitle') }}</div>
<!--							<button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('cancel')"></button>-->
						</div>
						<div class="modal-body">
							<p>{{ $t('register.successText') }}</p>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
import {required, email, minLength, sameAs} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";

import DivisionSelect from "@/components/DivisionSelect.vue";
import TeamSelect from "@/components/TeamSelect.vue";

import * as bootstrap from "bootstrap"

export default {
	components: {TeamSelect, DivisionSelect},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			registerForm: {
				name: '',
				email: '',
				personalNumber: '',
				division: null,
				team: null,
				password: '',
				passwordConfirm: ''
			},
			
			loading: false,
			
			registerSuccessModal: false,
			// registerSuccess: false,
			registerError: false
		}
	},
	validations() {
		return {
			registerForm: {
				name: {required},
				email: {required, email},
				personalNumber: {required},
				division: {required},
				team: {required},
				password: {required, minLength: minLength(8)},
				passwordConfirm: {required, minLength: minLength(8), sameAsPassword: sameAs(this.registerForm.password)}
			},
		}
	},
	
	methods: {
		submitRegister() {
			this.registerSuccess = false
			this.registerError = false
			
			this.v$.registerForm.$touch()
			if (!this.v$.registerForm.$error) {
				this.register()
			}
		},
		
		register() {
			this.loading = true
			
			const body = {
				name: this.registerForm.name,
				email: this.registerForm.email,
				personal_number: this.registerForm.personalNumber,
				team_id: this.registerForm.team.id,
				password: this.registerForm.password,
				password_confirmation: this.registerForm.passwordConfirm
			}
			
			this.$axios.post(`${this.$config.API_URL}/register`, body, this.$config.JS_HEADERS)
				.then((res) => {
					console.log(res)
					// this.registerSuccess = true
					
					this.registerSuccessModal.show()
					let self = this
					setTimeout(() => {
						self.registerSuccessModal.hide()
					}, 3000)
					
				}, (err) => {
					console.log(err)
					this.registerError = true
				}).finally(() => {
					this.loading = false
				})
		},
		
		initRegisterSuccessModal() {
			this.registerSuccessModal = new bootstrap.Modal('#registerSuccessModal')
			// this.registerSuccessModal.show()
		}
	},
	
	mounted() {
		this.initRegisterSuccessModal()
	}
}
</script>

<style lang="scss" scoped>
#zmen-form .page-register::v-deep(.register-wrap) {
	display: flex;
	flex-direction: column;
	padding-bottom: 30px;
	background: linear-gradient(to bottom, var(--zmen-form-background-gradient-light), var(--zmen-form-background-gradient-dark));
	
	.page-title {
		position: relative;
		margin: 60px 0 40px;
		font-family: var(--zmen-form-font-family);
		font-size: 25px;
		font-weight: 600;
		color: white;
		text-align: center;
		text-transform: uppercase;
		
		&:after {
			content: "";
			position: absolute;
			bottom: -15px;
			left: 50%;
			width: 50px;
			height: 5px;
			border-radius: 3px;
			background: linear-gradient(to right, var(--zmen-form-gradient-light), var(--zmen-form-gradient-dark));
			transform: translate(-50%, 0);
		}
	}
	
	.form-wrap {
		margin-left: 40px;
		margin-right: 40px;
		margin-bottom: 20px;
	}
	
	.btn-submit {
		align-self: center;
		width: calc(100% - 80px);
		max-width: 280px;
		margin: 20px 0 10px;
	}
	
	.submit-feedback {
		padding-left: 40px;
		padding-right: 40px;
		text-align: center;
	}
}
</style>